import { KREMEN_BELTS_MAIN } from './KREMEN_BELTS_MAIN'; // eslint-disable-line
import { KREMEN_BELTS_SALES } from './KREMEN_BELTS_SALES'; // eslint-disable-line
import { KREMEN_RETAILER } from './KREMEN_RETAILER'; // eslint-disable-line

export const DEVELOP_STORE = {
    ...KREMEN_BELTS_MAIN,
    ...KREMEN_RETAILER,
    // ...KREMEN_BELTS_SALES,
    URL: ['http://localhost:3000', 'http://localhost:3001'],
    // telegram_sender: !window?.location?.origin.includes('localhost'),
    telegram_sender: true,
};
